<template>
  <div class="basic-block block-uranaitv-desc-base" :style="styles">
    <div class="sec-mess">
      <!-- <div class="title">属性開抛でわかる<br>あなたのすべて</div>
      <div class="sec-subscr-previews">
        <subscr-fortune-preview
          :result-data="previewResultList[0]"
          :color-data="previewColors"
          :lp-id="lpId"
          class="preview-item"
        />
        <div class="comment">
          <img src="/static/img/recommend/lp/touwa/counselor7.jpg" alt="">
          <p>同じ星を持っている人が、みんな同じ人生をたどるわけではありません。<br>あなただけがもつ定め、運気の流れや人との出会い、そして節目ごとの選択が、あなたという人の道筋を作り上げていきます。</p>
        </div> -->
        <div class="fortune">
          <div class="title">人生を限界突破させる<br>斗弥の占い</div>
          <subscr-fortune-preview
            :result-data="previewResultList[0]"
            :color-data="previewColors"
            :lp-id="lpId"
            class="preview-item"
          />
        </div>
        <div class="tarot">
          <div class="title">＼初公開／<br>心の扉を、運命を開く<br>斗弥のオリジナルタロット</div>
          <img class="img1" src="/static/img/recommend/lp/touwa/tarot.png" alt="">
          <div class="msg">あなただけがもつ定め、運気の流れや人との出会い、そして節目ごとの選択が、あなたという人の道筋を作り上げていきます。<br>占いTVでは、斗弥オリジナルタロットで細かな運命の変化、相手の気持ちの変化、あなたが向かう先に待っているものをお伝えします。</div>
          <img class="img2" src="/static/img/recommend/lp/touwa/counselor8.png" alt="">
          <subscr-fortune-preview
            :result-data="previewResultList[1]"
            :color-data="previewColors"
            :lp-id="lpId"
            class="preview-item"
          />
        </div>
        <div class="menus">
          <div class="title">属性開抛＆タロットで<br>あなたの知りたいこと、<br>全て占います<br>占いTVで定額占い放題<br>メニュー例</div>
          <block-menus-item
            :target-info="targetInfo"
            :lp-id="lpId"
            :color-scheme="colorScheme"
            :selected-list="resultSelectMenuMod"
            :ga-event-categ="`LP${lpId}basicresult-subsc-button`"
            :base-col="targetInfo.tabedMenu.color.baseColor"
            :item-font-col="targetInfo.tabedMenu.color.itemFont"
            :frame-col="targetInfo.tabedMenu.color.frameColor"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubscrFortunePreview from '@/utvStore/components/recommend/lp/partials/SubscrFortunePreview'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockMenusItem from '@/utvStore/components/recommend/lp/blocks/BlockMenusItem'

export default {
  name: 'BlockUranaiTvDesc',
  components: {
    SubscrFortunePreview,
    LpBaseButton,
    BlockMenusItem
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    previewResultList: {
      type: Array,
      default: null,
    },
    subscUrl: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    previewColors(){
      return {
        gradStart: this.colorScheme.gradStart,
        gradEnd: this.colorScheme.gradEnd,
        previewBg: '#F9F5ED',
        previewBorder: '#000',
        font: '#32373f',
        head: this.colorScheme.second,
      }
    },
    resultSelectMenuMod(){
      const urlModList = this.targetInfo.resultSelectMenu.map(v => {
        return {...v, url:this.subscUrl}
      })
      return urlModList
    }
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-uranaitv-desc-base {
  background: #fff;
}
.sec-mess {
  padding: 0 0 40px;
  .title {
    font-weight: bold;
    font-size: 22px;
    line-height: 32px;
    text-align: center;
    margin: 0 auto 24px;
  }
  .comment {
    display: flex;
    margin: 24px auto;
    max-width: 400px;
    > img {
      flex: 0 1 auto;
      align-self: flex-end;
      width: 38.3%;
      max-width: 140px;
      margin: 0 9px 0 0;
    }
    > p {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      font-size: 15px;
      line-height: 22px;
      font-weight: bold;
      color: #fff;
      text-align: justify;
      background: $l_col_second;
      border-radius: 8px;
      padding: 18px 6px 18px 10px;
      margin: 0;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: calc(100% - 1px);
        margin: auto;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-right-color: $l_col_second;
      }
    }
  }
  /deep/ {
    .baseButton {
      padding: 0 10px;
    }
    .baseButton__button {
      font-size: 16px;
      background: linear-gradient(270deg, #F2D15D 0%, #FDA553 51.04%, #EE545E 100%);
      padding-left: 0;
      padding-right: 0;
    }
  }
  .fortune{
    padding: 0 20px 24px;
  }
  .tarot{
    padding: 0 0 24px;
    .msg{
      padding: 0 20px 24px;
    }
    .img1{
      width: 100%;
      margin: 0 auto 24px;
      display: block;
    }
    .img2{
      width: 150px;
      margin: 0 auto 24px;
      display: block;
    }
    .preview-item{
      margin: 0 20px;
      width: auto;
    }
  }
  .menus{
    padding: 0 20px;
  }
}
.sec-subscr-previews {
  padding: 0;
  .preview-item {
    // margin-bottom: 40px;
    &:last-of-type {
      // margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockUranaiTvDesc.vue